<!-- 消防控制记录页面 -->
<template>
  <div class="fileControl-record-container section-main__warp">
    <!--主页面 -->
    <div class="flex-row" style="height: 100%; width: 100%">
      <div class="section-mian_right">
        <!-- 右侧表格 -->
        <div class="section-main_table">
          <ioc-table
            ref="accessTab"
            :data="tableData"
            :option="tableOption"
            :page="page"
            @search-change="searchResult"
            @search-reset="resetQuery"
            @current-change="selectPage"
            @size-change="changeSize"
          >
            <template slot="search_operateTime">
              <div>
                <el-date-picker
                  type="datetime"
                  placeholder="请选择开始时间"
                  v-model="searchParams.startTime"
                  default-time="00:00:00"
                  style="width: 182px"
                ></el-date-picker>
                <span style="padding: 0 5px">至</span>
                <el-date-picker
                  type="datetime"
                  placeholder="请选择结束时间"
                  v-model="searchParams.endTime"
                  default-time="23:59:59"
                  style="width: 182px"
                ></el-date-picker>
              </div>
            </template>
            <template slot="menuLeft">
              <el-button
                type="primary"
                v-auth="'/fireControlRecord:export'"
                :loading="exportDisabled"
                @click="exportDocument"
                class="exportbtn"
                >{{ exportDisabled ? "导出中" : "导出" }}</el-button
              >
            </template>

            <template slot="search_deviceName">
              <!-- <el-cascader
                placeholder="请输入"
                v-model="caseDeviceName"
                :show-all-levels="false"
                clearable
                @change="cascaderChange"
                :options="hostName"
                :props="cascaderProps2"
                filterable
              ></el-cascader> -->
              <el-select
                filterable
                clearable
                v-model="searchParams.deviceName"
                placeholder="请选择"
              >
                <el-option
                  v-for="(item, index) in hostName"
                  :key="index"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </template>
            <!-- 回执结果点击跳转详情 -->
            <template slot="replySign" slot-scope="scope">
              <el-button type="text" @click="handleView(scope.row, scope.index)">
                {{ scope.row.replySign | dic("SENU096") }}
              </el-button>
            </template>
          </ioc-table>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { api } from "../api/index";
import { Dic, Bus, Dates } from "$utils";
import utils from "$utils";
import i18n from "@src/common/lib/i18n";
import { tableOption } from "../config/table";
export default {
  components: {},
  data() {
    return {
      caseDeviceName: [],
      cascaderProps2: {
        children: "children",
        label: "value",
        value: "value",
        expandTrigger: "hover",
      },
      exportDisabled: false,
      tableOption: tableOption(),
      // 分页属性设置
      page: {
        currentPage: 1,
        total: 10,
        pageSize: utils.Cache.get("CURRENT_PAGESIZE") || 10,
      },
      tableData: [],
      // 员工用户组列表查询参数
      searchParams: {
        deviceName: "",
      },
      areaDevGroupValue: [],
      areaDevGroup: [],
      detailData: {},
      workFlowData: [],
      hostName: [],
      nameArr: {},
    };
  },
  created() {
    this.nameArr = {};
    for (var i = 65; i < 91; i++) {
      this.nameArr[String.fromCharCode(i) + "区"] = [];
    }
    this.queryFireDevice();
  },
  mounted() {
    this.getList();
  },
  methods: {
    cascaderChange(value) {
      if (value.length) {
        this.searchParams.deviceName = value[1];
      } else {
        this.searchParams.deviceName = "";
      }
    },
    queryFireDevice() {
      this.$fetch(api.cms.queryFireDevice, {
        deviceMarkList: ["27", "28", "29"],
        pageNum: 1,
        pageSize: 10000,
        systemId: "200000024",
      }).then((response) => {
        if (response.success) {
          let newArr = [];
          let otherArr = [];
          response.returnObj.list.forEach((el, index) => {
            // let nameId = el.thirdDeviceName.slice(0, 2);
            // if (this.nameArr[nameId]) {
            //   this.nameArr[nameId].push({
            //     value: el.thirdDeviceName,
            //     id: el.thirdDeviceId,
            //     deviceID: el.deviceID,
            //   });
            // } else {
            //   otherArr.push({
            //     value: el.thirdDeviceName,
            //     id: el.thirdDeviceId,
            //     deviceID: el.deviceID,
            //   });
            // }
                newArr.push({
                value: el.thirdDeviceName,
                label: el.thirdDeviceName,
              });
          });
          // for (let key in this.nameArr) {
          //   if (this.nameArr[key].length > 0) {
          //     newArr.push({
          //       value: key,
          //       label: key,
          //       children: this.nameArr[key],
          //     });
          //   }
          // }
          // otherArr.push({
          //   value: "电气火灾",
          //   id: "电气火灾",
          // });
          // newArr.push({
          //   value: "其他",
          //   label: "其他",
          //   children: otherArr,
          // });
          // console.log(newArr)
          this.hostName = JSON.parse(JSON.stringify(newArr));
        } else {
          // this.$message.error(response.msgContent || "获取设备详情失败");
        }
      });
    },
    //导出
    exportDocument() {
      const params = {
        operatorName: this.searchParams?.operatorName,
        deviceName: this.searchParams?.deviceName,
        thirdDeviceId: this.searchParams?.thirdDeviceId,
        beginTime: this.searchParams.startTime
          ? Dates.format(this.searchParams.startTime)
          : "", //'开始时间',
        endTime: this.searchParams.endTime ? Dates.format(this.searchParams.endTime) : "", //结束时间',
        plateCode: this.searchParams?.plateCode,
      };
      this.exportDisabled = true;
      this.$fetchDownLoad(api.controlRecord.exportFirefightControlRecordList, params, {
        responseType: "arraybuffer",
      }).then((response) => {
        console.log(response);
        if (response.data || response.success) {
          const content = response.data;
          const blob = new Blob([content], {
            type: "application/vnd.ms-excel",
          });
          const fileName =
            "消防设备控制记录" + Dates.format(Date.now(), "yyyyMMddHHmmssms") + ".xlsx";
          if ("download" in document.createElement("a")) {
            // 非IE下载
            const elink = document.createElement("a");
            elink.download = fileName;
            elink.style.display = "none";
            elink.href = URL.createObjectURL(blob);
            document.body.appendChild(elink);
            elink.click();
            URL.revokeObjectURL(elink.href); // 释放URL 对象
            document.body.removeChild(elink);
          } else {
            // IE10+下载
            navigator.msSaveBlob(blob, fileName);
          }
        } else {
          this.$message.error(response.msgContent || "请求失败，请稍后重试");
        }
        this.exportDisabled = false;
      });
    },
    // 获取列表
    getList() {
      // console.log(this.searchParams);
      const params = {};
      params.operatorName = this.searchParams.operatorName;
      params.deviceName = this.searchParams.deviceName;
      params.thirdDeviceId = this.searchParams.thirdDeviceId;
      params.beginTime = this.searchParams.startTime
        ? Dates.format(this.searchParams.startTime)
        : ""; //'开始时间',
      params.endTime = this.searchParams.endTime
        ? Dates.format(this.searchParams.endTime)
        : ""; //结束时间',
      params.pageNum = this.page.currentPage;
      params.pageSize = this.page.pageSize;
      const loading = this.$loading({
        lock: true,
        text: "请求中",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      this.$fetch(api.controlRecord.queryFirefightControlRecordList, params).then(
        (response) => {
          setTimeout(() => {
            loading.close();
          }, 500);

          if (!response.success) {
            this.$message.error(response.msgContent);
            return;
          }
          this.tableData = response.returnObj
            ? Object.freeze([...response.returnObj.list])
            : [];
          this.page.total = response.returnObj ? response.returnObj.total : 0;
          this.$refs.accessTab.selectClear();
        }
      );
    },
    // 查询按钮事件
    searchResult(param) {
      this.searchParams = Object.assign(this.searchParams, param);
      this.page.currentPage = 1;
      this.getList();
    },
    // 重置按钮
    resetQuery() {
      this.searchParams = {};
      this.caseDeviceName = [];
      this.getList();
    },
    // 点击上一页下一页按钮
    selectPage(val) {
      this.page.currentPage = val;
      this.getList();
    },
    // 修改每页数据数量
    changeSize(val) {
      this.page.currentPage = 1;
      this.page.pageSize = val;
      this.getList();
    },
    handleView(row, index) {
      this.$refs.accessTab.rowView(row, index);
    },
  },
};
</script>
<style lang="scss">
@import "~@src/common/assets/style/mixin";
// .el-cascader-panel {
//   @include set_theme_color(background-color, input-disabled-bg-color);
//   @include set_theme_color(border-color, active-border-color);
//   border: 1px solid;
//   border-radius: 3px;
// }
</style>
<style lang="scss" scoped>
@import "~@src/common/assets/style/mixin";

.fileControl-record-container {
  // width: 100%;
  // height: 100%;
  .el-table__fixed-right-patch {
    display: none;
  }
  .el-dialog {
    .el-date-editor.el-input,
    .el-date-editor.el-input__inner {
      width: 260px;
    }
  }
  .export-tips {
    margin-left: 5px;
    color: red;
    vertical-align: middle;
  }
}
</style>
